export interface OrderTimelineResponse {
  orderTimelineEvents: OrderTimeline
}

export interface OrderTimeline {
  occurredEvents: OrderTimelineEvent[]
  expectedEvents: OrderTimelineEvent[]
}

export interface OrderTimelineEvent {
  fromSystemName: string
  toSystemName: string
  description: string
  date: string
  kind: string
  name: string
}

export interface FullTimelineEvent {
  eventOrigin: string;
  eventTarget: string;
  createdAt: string;
  description: string;
  kind: string;
  name: string;
  data: unknown;
  [key: string]: unknown;
}

export type AlertCode =
  | 'INVOICE_EMITTED'
  | 'INVOICE_PENDING'
  | 'INCON_PAGTO'
  | 'INCON_TERRAIN';

export type AlertSeverity = 'error' | 'warning' | 'info';

export type ReprocessLockReason =
  | 'criteria_not_met'
  | 'active_workflow'
  | 'missing_role'
  | null;

export interface OrderAlert {
  code: AlertCode;
  severity: AlertSeverity;
  message: string;
  invoice?: string | null;
  showReprocessButton: boolean;
}

export interface OrderReprocessInfo {
  allowed: boolean;
  matchesCriteria: boolean;
  hasActiveWorkflow: boolean;
  lockReason: ReprocessLockReason;
}

export interface KruzerOrderTimelineEvent {
  fromSystemName: string;
  toSystemName: string;
  date: string;
  name: string;
  description: string | null;
  kind: string | null;
  payload: unknown | null;
}

export interface KruzerOrderTimeline {
  occurredEvents: KruzerOrderTimelineEvent[];
}

export interface OrderTimelineEnvelope {
  orderFlowType: string;
  orderTimelineEvents: OrderTimeline;
  alerts: OrderAlert[];
  reprocess: OrderReprocessInfo;
  kruzer: KruzerOrderTimeline;
}

export const DEFAULT_REPROCESS_INFO: OrderReprocessInfo = {
  allowed: false,
  matchesCriteria: false,
  hasActiveWorkflow: false,
  lockReason: 'criteria_not_met',
};
